/**
 * Zip arrays together.
 */
export function zip(...arrays) {
    return Array.from(enumerateZip(...arrays));
}
/**
 * Zip arrays together for enumeration.
 */
export function* enumerateZip(...arrays) {
    arrays = arrays.filter(Boolean);
    const length = Math.max(...arrays.map((collection) => collection.length));
    for (let i = 0; i < length; ++i) {
        yield arrays.map((array) => array[i]);
    }
}
//# sourceMappingURL=zip.js.map